import axiosClient from "./axiosClient";
import visaLambda from "./visaLambda";
import * as Config from "../constants/Config";
let { appname } = window.app;

const tmdbApi = {
  websitedefaults: (params) => {
    const url = "/config?" + 'appname=' + appname;
    return axiosClient.get(url, params);
  },
  fetchTransactionHistory: (params) => {
    const token = localStorage.getItem("token");
    let url = "/fetchTransactionHistory?" + 'appname=' + appname + "&token=" + token;
    if (params) {
      Object.keys(params).forEach(key => {
        url += `&${key}=${encodeURIComponent(params[key])}`;
      })
    }
    return axiosClient.get(url, {});
  },
  fetchTransactionHistory1: (params) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");
    let url = "/fetchTransactionHistory?" + 'appname=' + appname + "&token=" + token + "&userid=" + userid;
    if (params) {
      Object.keys(params).forEach(key => {
        url += `&${key}=${params[key]}`;
      })
    }
    return axiosClient.get(url, {});
  },
  announceResult: (cpcid, data) => {
    let url = `/announceResult?appname=${appname}&cpcid=${cpcid}`
    return axiosClient.post(url, data);
  },
  sendCpcEmail: (cpcid) => {
    let url = `/recordingEmail?appname=${appname}&cpcid=${cpcid}`
    return axiosClient.post(url, {});
  },
  cpcPayments: (cpcid) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")
    let url = `/cpcPayments?appname=${appname}&cpcid=${cpcid}&userid=${userid}&token=${token}`;
    return axiosClient.post(url, {});
  },
  subscriptionPayments: (subid) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")
    let url = `/cpcPayments?appname=${appname}&type=subscription&subscriptionplanid=${subid}&userid=${userid}&token=${token}`;
    return axiosClient.post(url, {});
  },
  modulePayments: (moduleid) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")

    let url = `/cpcPayments?appname=${appname}&moduleid=${moduleid}&userid=${userid}&token=${token}`;
    return axiosClient.post(url, {});
  },
  verifyPayments: (cpcid, moduleid, res, razorPayID,status=null) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")
    let url = `/verifyPayments?appname=${appname}&moduleid=${moduleid}&cpcid=${cpcid}&userid=${userid}&token=${token}&razorPayID=${razorPayID}`;
    if(status !== null){
      url= url+"&status="+status;
    }
    return axiosClient.post(url, res);
  },
  lookupInfo: (type) => {
    let url = `/lookupInfo?appname=${appname}&type=${type}`
    return axiosClient.get(url);
  },
  getmoduleInfo: (pageName) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")

    let url = "/moduleInfo?" + 'appname=' + appname + "&projection=adminmodule";
    if (pageName) {
      url = url + "&pageName=" + pageName
    }
    return axiosClient.get(url);
  },

  cpcInfo: (pageName, pageNumber, pageSize) => {
    const userid = localStorage.getItem("userId")
    // let url = "/cpcInfo?" + 'appname=' + appname + "&status=" + status
    const token = localStorage.getItem("token")
    let url = "/cpcInfo?" + 'appname=' + appname
    if (token) {
      url = "/cpcInfo?" + 'appname=' + appname + "&userid=" + userid + "&token=" + token;
    }

    if (pageName) {
      url = url + "&pageName=" + pageName
    }
    // paged response is { data, totalCount }; without paging it is a plain array
    if (pageNumber) {
      url = url + "&paginate=true&pageNumber=" + pageNumber + "&pageSize=" + pageSize
    }

    return axiosClient.get(url);
  },
  cpcInfoAdmin: (pageName, pageNumber, pageSize) => {
    const userid = localStorage.getItem("userId")
    // let url = "/cpcInfo?" + 'appname=' + appname + "&status=" + status
    const token = localStorage.getItem("token")
    let url = "/cpcInfo?" + 'appname=' + appname
    if (token) {
      url = "/cpcInfo?" + 'appname=' + appname + "&token=" + token;
    }
    if (pageName) {
      url = url + "&pageName=" + pageName
    }
    if (pageNumber) {
      url = url + "&paginate=true&pageNumber=" + pageNumber + "&pageSize=" + pageSize
    }

    return axiosClient.get(url);
  },
  cpcInfoWithouttoken: (pageName) => {
    const userid = localStorage.getItem("userId")
    // let url = "/cpcInfo?" + 'appname=' + appname + "&status=" + status
    const token = localStorage.getItem("token")
    let url = "/cpcInfo?" + 'appname=' + appname;
    if (pageName) {
      url = url + "&pageName=" + pageName
    }

    return axiosClient.get(url);
  },
  cpcAnswersInfo: (cpcid) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    let url = "/cpcAnswersInfo?" + 'appname=' + appname + "&userid=" + userid + "&cpcid=" + cpcid + "&token=" + token;

    return axiosClient.post(url);
  },
  cpcannounceResult: (cpcid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/announceResult?" + 'appname=' + appname + "&cpcid=" + cpcid + "&token=" + token;

    return axiosClient.post(url);
  },
  cpcviewResult: (cpcid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/studentCompletedQuiz?" + 'appname=' + appname + "&cpcid=" + cpcid + "&token=" + token;

    return axiosClient.get(url);
  },
  studentCompletedQuiz: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/studentCompletedQuiz?" + 'appname=' + appname + "&userid=" + userid + "&token=" + token;

    return axiosClient.get(url);
  },
  cpcsendResult: (payload, cpcid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/sendResult?" + 'appname=' + appname + "&cpcid=" + cpcid + "&token=" + token;

    return axiosClient.post(url, payload);
  },
  cpcCaseSubmit: (payload, cpcid, caseid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/caseSubmit?" + 'appname=' + appname + "&cpcid=" + cpcid + "&caseid=" + caseid + "&token=" + token;

    return axiosClient.post(url, payload);
  },
  cpcPointSubmit: (payload, cpcid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/caseAnswerSubmit?" + 'appname=' + appname + "&cpcid=" + cpcid + "&token=" + token;

    return axiosClient.post(url, payload);
  },
  cpcInfoById: (cpcid) => {
    const token = localStorage.getItem("token")
    let url = "/cpcInfo?" + 'appname=' + appname + "&cpcid=" + cpcid + "&token=" + token;
    return axiosClient.get(url);
  },
  participantUsersInfo: (cpcid) => {
    const token = localStorage.getItem("token")
    let url = "/registeredusers?" + 'appname=' + appname + "&cpcid=" + cpcid + "&token=" + token;
    return axiosClient.get(url);
  },
  lectureLibraryInfo: () => {
    const token = localStorage.getItem("token")
    let url = "/lectureLibraryInfo?" + 'appname=' + appname + "&pageName=ACTIVE"
    return axiosClient.get(url);
  },
  cpcCaseInfo: (caseid) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    let url = "/learningCaseInfo?" + 'appname=' + appname + '&token=' + token + "&status=ACTIVE&userid=" + userid + "&case=true";
    let params = {

    }
    if (caseid) {
      params = {
        caseid: caseid
      }

    }
    return axiosClient.post(url, params);
  },
  cpcCaseModuleInfo: (caseid, moduleid) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    let url = "/learningCaseInfo?" + 'appname=' + appname + '&token=' + token + "&status=ACTIVE&userid=" + userid + "&case=true&moduleid=" + moduleid + "&tableName=moduleCases";
    let params = {

    }
    if (caseid) {
      params = {
        caseid: caseid
      }

    }
    return axiosClient.post(url, params);
  },
  cpcCaseMdouleInfo: (caseid, type, moduleid) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    let url = "/learningCaseInfo?" + 'appname=' + appname + '&token=' + token + "&status=ACTIVE&userid=" + userid + "&case=true" + '&tableName=moduleCases' + "&moduleid=" + moduleid;
    let params = {

    }

    params = {
      caseid: caseid
    }
    //  if(type=="user"){
    //             params["moduleid"] = moduleid;
    //         }
    return axiosClient.post(url, params);
  },
  cpcCaseInfoForModule: (tableName, caseid, moduleid) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    let url = "/learningCaseInfo?" + 'appname=' + appname + '&token=' + token + "&pageName=ACTIVE&userid=" + userid + "&case=true";
    if (tableName) {
      url = url + "&tableName=" + tableName;
    }
    if (moduleid) {
      url = url + "&moduleid=" + moduleid
    }else{
         url = url + "&projection=modulecases"
    }
    return axiosClient.post(url, { caseid: caseid });
  },
  searchCpcCases: (searchTerm) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    const url = "/learningCaseInfo?" + 'appname=' + appname + '&token=' + token + "&pageName=ACTIVE&userid=" + userid + "&case=true&projection=modulecases&search=" + encodeURIComponent(searchTerm);
    return axiosClient.post(url, {});
  },
    getFeedbackApi: ( caseid, moduleid,type) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    let url = "/getFeedback?" + 'appname=' + appname + '&token=' + token + "&moduleid="+moduleid+"&caseid="+caseid;
    if (type === "admin") {
  url += "&type=" + type;
}else{

  url +="&userid="+userid+"&projection=doctor";
}
    return axiosClient.post(url,{});
  },
  addCpcParticipants: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/addCpcParticipants?" + 'appname=' + appname + "&userid=" + userid
    return axiosClient.post(url, params);
  },
addFeedback: (params, isUpdate) => { 
    const userid = localStorage.getItem("userId");
    console.log('Params:', params);
    console.log('UserID:', userid);
    let url = `/` + (isUpdate ? "updateFeedback" : "addFeedback") + `?appname=${appname}&userid=${userid}&caseid=${params.caseid}&moduleid=${params.moduleid}`;

    // let url =
    //     "/addFeedback?" +
    //     "appname=" + appname +
    //     "&userid=" + userid +
    //     "&caseid=" + params.caseid +
    //     "&moduleid=" + params.moduleid;

    console.log("POST URL:", url);
    console.log("POST Body:", { feedbackDescription: params.feedbackDescription });

    return axiosClient.post(url, { feedbackDescription: params.feedbackDescription });
},


  getParticipatedTerms: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/participatedTerms?" + 'appname=' + appname + "&userid=" + userid + "&cpcid=" + params
    return axiosClient.post(url);
  },

  joinMeetingCount: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/joinMeetingCount?" + 'appname=' + appname + "&userid=" + userid + "&token=" + token
    return axiosClient.post(url, params);
  },

  getHistoryresult: (params,value) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/historyresult?" + 'appname=' + appname + "&userid=" + userid + "&token=" + token + "&moduleid=" + params;
    if(value === true){
      url = url+ "&moduleType=FELLOWSHIP";
    }
    return axiosClient.get(url);
  },
  addCpcParticipantAnswers: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/addCpcParticipantAnswers?" + 'appname=' + appname + "&userid=" + userid + "&token=" + token;
    return axiosClient.post(url, params);
  },
  addLearningcParticipantAnswers: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/addLearningcParticipantAnswers?" + 'appname=' + appname + "&userid=" + userid + "&token=" + token;
    return axiosClient.post(url, params);
  },
  updateLearningcParticipantAnswers: (params,learninguniqueid) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/updateLearningcParticipantAnswers?" + 'appname=' + appname + "&userid=" + userid +"&learninguniqueid="+learninguniqueid+ "&token=" + token;
    return axiosClient.post(url, params);
  },

    updatePathologySummaryApi: (fellowuserid,learninguniqueid,payload) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")

    let url = "/updatePathologistSummary?" + 'appname=' + appname + "&fellowUserid=" + fellowuserid + "&learninguniqueid=" + learninguniqueid +"&token=" + token;
    return axiosClient.post(url, payload);
  },
  cpcInfoById: (cpcid) => {
    const token = localStorage.getItem("token")
    let url = "/cpcInfo?" + 'appname=' + appname + "&cpcid=" + cpcid + "&token=" + token;
    return axiosClient.get(url);
  },
  learningModulePercentile: (moduleId) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")

    let url = "/learningModulePercentile?" + 'appname=' + appname + "&userid=" + userid + "&learninguniqueid=" + moduleId + "&token=" + token;
    return axiosClient.get(url);
  },

    learningModulePercentile2: (moduleId,fellowid,learninguniqueid) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")

    let url = "/learningModulePercentile?" + 'appname=' + appname + "&userid=" + fellowid + "&moduleid=" + moduleId +"&learninguniqueid="+learninguniqueid+ "&token=" + token;
    return axiosClient.get(url);
  },



  getCPCModules: () => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId")

    let url = "/moduleInfo?" + 'appname=' + appname + "&type=CPC Module" + "&pageName=ACTIVE" + "&projection=title";
    return axiosClient.get(url);
  },
  cpcParticipantAnswersInfo: (cpcid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/cpcParticipantAnswersInfo?" + 'appname=' + appname + "&userid=" + userid + "&cpcid=" + cpcid
    return axiosClient.get(url);
  },
    getBiopsyCases: (payload) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/getBiopsyCases?" + 'appname=' + appname + "&userid=" + userid + "&case=true"
    return axiosClient.post(url,payload);
  },
  cpcParticipantAnswersInfoByUser: (cpcid, userId) => {
    const token = localStorage.getItem("token")
    let url = "/cpcParticipantAnswersDetails?" + 'appname=' + appname + "&userid=" + userId + "&cpcid=" + cpcid + "&token=" + token + "&isAdmin=true" + "&projection=cpcanswers";
    return axiosClient.get(url);
  },
  latestCpcTopWinners: () => {
    let url = "/cpcWinners?" + 'appname=' + appname;
    return axiosClient.get(url);
  },

  librarytaginfo: (type) => {
    // const userid = localStorage.getItem("userId")
    if (type) {

    }
    const token = localStorage.getItem("token")
    const url = `/librarytaginfo?appname=${appname}${token ? `&token=${token}` : ''}`;
    return axiosClient.get(url);
  },
  getPlans: () => {
    const token = localStorage.getItem("token")
    const url = "/getPlans?" + 'appname=' + appname;
    return axiosClient.get(url);
  },
  updatePlans: (params) => {
    const payload = params
    const token = localStorage.getItem("token")
    const url = "/updatePlans?" + 'appname=' + appname + '&subscriptionplanid=' + params?.subscriptionplanid;
    return axiosClient.post(url, payload);
  },
  addPayment: (params) => {
    const userId = localStorage.getItem("userId")
    const url = "/addPayment?appname=" + appname + "?userId=" + userId;
    return axiosClient.post(url, params);
  },
  appMenus: (params) => {
    const url = "/menus?" + 'appname=' + appname + '&appType=client&page=landingpage';
    return axiosClient.get(url, params);
  },

  signin: (params) => {


    let { userType, ...payload } = params
    // const userType = localStorage.getItem("userType") || localStorage.getItem("userType")
    console.log('checkUserType in signin api', userType, params)
    let url = "/signIn?appname=" + appname + "&loginType=" + params?.logintype;
    if (userType) {
      url += `&userType=${userType}`;
    }
    return axiosClient.post(url, params);
  },
  resendOtp: (params) => {
    const userType = localStorage.getItem("userType") || localStorage.getItem("userType")
    const url = "/signIn?appname=" + appname + "&loginType=" + params?.logintype;
    return axiosClient.post(url, params);
  },
  otpverify: (params) => {
    const userType = localStorage.getItem("userType")
    const url = "/otpVerify?appname=" + appname + "&loginType=" + params?.logintype;
    return axiosClient.post(url, params);
  },
  adminsignin: (params) => {
    const url = "/signIn?appname=" + appname;
    return axiosClient.post(url, params);
  },
  CreatePassword: (userid, usertype, params) => {
    const url = "/setPassword?appname=" + appname + "&userid=" + userid;
    return axiosClient.post(url, params);
  },

  setPassword: (params) => {
    const userid = localStorage.getItem("userId")
    const usertype = localStorage.getItem("userType")
    const url = "/setPassword?appname=" + appname + "&userid=" + userid
    return axiosClient.post(url, params);
  },
  ForgotPassword: (params) => {
    const url = "/forgotPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },

  Adduser: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/user?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },

  AddQuiz: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addQuiz?appname=" + appname + "&userid=" + userid + "&token=" + token
    return axiosClient.post(url, params);
  },

  UpdateQuiz: (params, quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuiz?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid
    return axiosClient.post(url, params);
  },

  AddAnswer: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addAnswer?appname=" + appname + "&userid=" + userid + "&token=" + token
    return axiosClient.post(url, params);
  },

  UpdateAnswer: (params, answerid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateAnswer?appname=" + appname + "&userid=" + userid + "&answerid=" + answerid + "&token=" + token
    return axiosClient.post(url, params);
  },

  AddQuestion: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addQuestion?appname=" + appname + "&userid=" + userid + "&token=" + token
    return axiosClient.post(url, params);
  },

  UpdateQuestion: (params, questionid, quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuestion?appname=" + appname + "&userid=" + userid + "&questionid=" + questionid + "&quizid=" + quizid
    return axiosClient.post(url, params);
  },

  quizParticipation: (params, liveParticipants, clientid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizParticipants?appname=" + appname + "&liveparticipation=" + liveParticipants + "&clientid=" + clientid
    return axiosClient.post(url, params);
  },

  announceResult: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/anounceResult?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid
    return axiosClient.post(url);
  },

  duplicateQuiz: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/duplicateQuiz?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid
    return axiosClient.post(url);
  },

  viewResult: (participantId) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/viewResult?appname=" + appname + "&userid=" + userid + "&participationid=" + participantId
    return axiosClient.post(url);
  },
  signUp: (params) => {
    const url = "/signUp?appname=" + appname;
    return axiosClient.post(url, params);
  },
  Login: (params) => {
    // const userType = localStorage.getItem("userType")
    const url = "/userSignIn?appname=" + appname;
    return axiosClient.post(url, params);
  },
  Logout: (params) => {
    const url = "/clientSignout?appname=" + appname;
    return axiosClient.post(url, params);
  },
  winnerSubmit: (params, quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/winnerUpdate?appname=" + appname + "&quizid=" + quizid
    return axiosClient.post(url, params);
  },

  casesInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/learningCaseInfo?appname=" + appname + "&userid=" + userid + "&pageName=ACTIVE"
    return axiosClient.post(url, {});
  },
  bulkcasesInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/learningCaseInfo?appname=" + appname + "&userid=" + userid +  "&projection=admincases"+ "&token="+token

    return axiosClient.post(url, {});
  },

 
  // answerInfo: (page,asset,sorting) => {
  //   const token = localStorage.getItem("token")
  //   const userid = localStorage.getItem("userId")
  //   const url = "/answerInfo?appname=" + appname + "&token=" + token+"&PageNumber=" + page + "&assetcount=" + asset+"&type="+sorting;
  //   return axiosClient.post(url, {});
  // },
  answerInfo: (pageNumber, pageSize, search) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");

    let url = `/answerInfo?appname=${appname}&token=${token}`;
    if (search) {
      url += "&search=" + encodeURIComponent(search.trim());
    }
    // paged response carries totalCount; without paging every answer comes back (used by dropdowns)
    if (pageNumber) {
      url += "&paginate=true&pageNumber=" + pageNumber + "&pageSize=" + pageSize;
    }

    // // only add sorting if available
    // if (sorting !=="") {
    //   url += `&type=${sorting}`;
    // }

    return axiosClient.post(url, {});
  },

  answerSearchInfo: (params, page, asset) => {
    // console.log("paramssssssssssssssssssssssssssssss", params);
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");
    const url = "/answerInfo?appname=" + appname + "&search=" + encodeURIComponent(params.trim()) + "&PageNumber=" + page + "&assetcount=" + asset;
    return axiosClient.post(url, {});
  },


  deleteAnswer: (answerid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateAnswer?appname=" + appname + "&userid=" + userid + "&answerid=" + answerid + "&type=delete"
    return axiosClient.post(url, {});
  },
  deleteFeedback: (moduleid, caseid, feedbackid) => {
  const token = localStorage.getItem("token")
  const userid = localStorage.getItem("userId")
  const url = "/deleteFeedback?appname=" + appname 
  return axiosClient.post(url, feedbackid);
},
  deleteEntireModuleFeedback: (moduleid,caseid) => {
  const token = localStorage.getItem("token")
  const userid = localStorage.getItem("userId")
  const url = "/deleteFeedback?appname=" + appname+"&moduleid=" + moduleid +"&type=module"+"&caseid="+caseid
  return axiosClient.post(url, {});
},

  quizInfo: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    let url = "/learningModulePercentile?" + 'appname=' + appname + "&userid=" + userid + "&learninguniqueid=" + params;
    return axiosClient.get(url, {});
  },

  quizInfoId: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&quizid=" + quizid + "&token=" + token
    return axiosClient.post(url, {});
  },

  ViewResults: () => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/viewResult?appname=" + appname + "&clientid=" + clientid + "&token=" + token
    return axiosClient.post(url, {});
  },

  viewResult1: (date) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/viewResult?appname=" + appname + "&clientid=" + clientid + "&date=" + date + "&token=" + token
    return axiosClient.post(url, {});
  },
  SignOutUser: (params, value) => {
    let payload = params
    console.log('params', params);
    console.log('value', value);
    // const url = "/signout?appname="+appname+"&emailid="+params.emailId;
    const url = "/signout?appname=" + appname;
    return axiosClient.post(url, payload);
  },
  reportsInfo: (quizId) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/reports?appname=" + appname + "&userid=" + userid + "&quizid=" + quizId + "&token=" + token
    return axiosClient.post(url, {});
  },
  SingleReports: (id) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/reports?appname=" + appname + "&quizid=" + id + "&token=" + token
    return axiosClient.post(url, {});
  },
  winnersInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/winner?appname=" + appname + "&userid=" + userid + "&token=" + token
    return axiosClient.post(url, {});
  },
  configData: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/configData?appname=" + appname
    return axiosClient.get(url, {});
  },

  quizHomeInfo: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client" + "&status=all"
    return axiosClient.post(url, {});
  },


  contactus: (obj) => {
    const token = localStorage.getItem("token")
    const url = "/contactus?appname=" + appname + "&loginType=otp&token=" + token
    return axiosClient.post(url, obj);
  },

  quizInfoCompeleted: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client&status=COMPLETED&token=" + token
    return axiosClient.post(url, {});
  },

  quizHomeFilterInfo: (status) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client&status=" + status + "&token=" + token
    return axiosClient.post(url, {});
  },

  quizSearchInfo: (search) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&search=" + search + "&token=" + token
    return axiosClient.post(url, {});
  },
  quizReportsSearchInfo: (search) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/quizInfo?appname=" + appname + "&userid=" + userid + "&type=client&status=COMPLETED&search=" + search + "&token=" + token
    return axiosClient.post(url, {});
  },

  deleteQuiz: (quizid) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuiz?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid + "&type=delete" + "&token=" + token
    return axiosClient.post(url, {});
  },
  deleteQuizFile: (quizid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/deleteQuizFile?appname=" + appname + "&quizid=" + quizid + "&token=" + token
    return axiosClient.post(url, params);
  },
  deleteQuestion: (quizid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuestion?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid + "&type=delete&token=" + token
    return axiosClient.post(url, params);
  },

  deleteQuestionslist: (quizid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateQuestion?appname=" + appname + "&userid=" + userid + "&quizid=" + quizid + "&type=delete&token=" + token
    return axiosClient.post(url, params);
  },

  deleteImage: (questionid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/deleteFiles?appname=" + appname + "&questionid=" + questionid + "&token=" + token
    return axiosClient.post(url, params);
  },

  deleteHistoricFiles: (caseid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/filesDelete?appname=" + appname + "&caseid=" + caseid + "&token=" + token
    return axiosClient.post(url, params);
  },
  deleteHistoricModuleFiles: (caseid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/filesDelete?appname=" + appname + "&caseid=" + caseid + "&token=" + token + "&tableName=moduleCases"
    return axiosClient.post(url, params);
  },
  // deleteHistoricModuleFilesById: (caseid, params, moduleid, isModuleCaseUpload) => {
  //   const token = localStorage.getItem("token")
  //   const userid = localStorage.getItem("userId")
  //   const url = "/filesDelete?appname=" + appname + "&caseid=" + caseid + "&token=" + token + "&tableName=moduleCases&moduleid=" + moduleid + "&isModuleCaseUpload=" + isModuleCaseUpload
  //   return axiosClient.post(url, params);
  // },
  deleteHistoricModuleFilesById: (caseid, params, moduleid, isModuleCaseUpload) => {
  const token = localStorage.getItem("token");
  const userid = localStorage.getItem("userId");
  let url = `/filesDelete?appname=${appname}&caseid=${caseid}&token=${token}&tableName=moduleCases&moduleid=${moduleid}`;
  if (isModuleCaseUpload !== undefined && isModuleCaseUpload !== null && isModuleCaseUpload !== "") {
    url += `&isModuleCaseUpload=${isModuleCaseUpload}`;
  }
  return axiosClient.post(url, params);
},

  deleteModuleFilesWithTable: (caseid, params, tableName) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/filesDelete?appname=" + appname + "&caseid=" + caseid + "&token=" + token + "&tableName=" + tableName
    return axiosClient.post(url, params);
  },
  deleteModuleFiles: (caseid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/filesDelete?appname=" + appname + "&moduleid=" + caseid + "&token=" + token
    return axiosClient.post(url, params);
  },
  deleteOmeFiles: (caseid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/deleteFiles?appname=" + appname + "&caseid=" + caseid + "&token=" + token
    return axiosClient.post(url, params);
  },
  deleteOmeModuleFiles: (caseid, params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/deleteFiles?appname=" + appname + "&caseid=" + caseid + "&token=" + token + "&tableName=moduleCases"
    return axiosClient.post(url, params);
  },
  deleteOmeModuleFilesById: (caseid, params, moduleid, isModuleCaseUpload = false) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/deleteFiles?appname=" + appname + "&caseid=" + caseid + "&token=" + token + "&tableName=moduleCases&moduleid=" + moduleid + "&isModuleCaseUpload=" + isModuleCaseUpload
    return axiosClient.post(url, params);
  },

  questionInfo: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/questionInfo?appname=" + appname + "&quizid=" + params.quizid + "&token=" + token
    return axiosClient.post(url, {});
  },

  getContent: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/content?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  dataImport: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/importData?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  getCompany: (params) => {
    const token = localStorage.getItem("token")
    const url = "/companies?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },

  SaveClient: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/client?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },
  SaveClientData: (params) => {
    const payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/client?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.put(url, payload);
  },
  FollowUp: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/followup?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },

  AddCompany: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/company?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, params);
  },

  getAccount: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/accountmangers?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.get(url, params);
  },

  getCategory: (params) => {
    const token = localStorage.getItem("token")
    // const url = "/category?appname=" + appname + "&token=" + token +"&status=ACTIVE";
    const url = "/category?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },

  getLookUp: (params) => {
    const token = localStorage.getItem("token")

    let payload = params
    let projection = params?.projection ? params?.projection : "";
    let status = params?.status ? params?.status : "";
    let url = "/lookups?appname=" + appname + "&token=" + token;

    if (projection != "") { url = url + `&projection=tiny` }
    if (status != "") { url = url + `&status=ACTIVE` }

    if (payload.hasOwnProperty('projection')) delete payload['projection']
    if (payload.hasOwnProperty('status')) delete payload['status']

    return axiosClient.post(url, payload);

  },

  getUserData: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/userInfo?appname=" + appname + "&userId=" + userid
    return axiosClient.get(url);
  },

  getPathologist: () => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userType")
    const url = "/userInfo?appname=" + appname + "&userType=PATHOLOGIST"
    return axiosClient.get(url);
  },

  getClientData: () => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/clientInfo?appname=" + appname + "&clientid=" + clientid + "&token=" + token
    return axiosClient.post(url);
  },

  filterCategory: (params) => {
    const userid = localStorage.getItem("userId")
    const token = localStorage.getItem("token")
    //   let pageNumber = params.pageNumber || 1;
    //    let assetcount = params.assetcount || 10;
    // let cat = params.category || "";
    let url = "/content?appname=" + appname + "&token=" + token + '&userid=' + userid;
    // if( pageNumber != "") { url = url + `&pageNumber=${pageNumber}`}
    // if( assetcount != "") {url = url + `&assetcount=${assetcount}`}
    return axiosClient.post(url, params);

  },

  userDataUpdate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const usertype = localStorage.getItem("userType")

    const url = "/updateUser?appname=" + appname + "&userid=" + userid
    return axiosClient.post(url, params);
  },
  userDelete: (userid) => {

    const url = "/updateUser?appname=" + appname + "&userid=" + userid + "&type=delete"
    return axiosClient.post(url, {});
  },

  biopsyDelete: (code) => {

    const url = "/updateLookup?appname=" + appname + "&lookupcode=" + code + "&type=Biopsy&statusType=delete"
    return axiosClient.post(url, {});
  },
  biopsyCaseDelete: (code) => {

    const url = "/updateBiopsyCase?appname=" + appname + "&patientid=" + code + "&type=delete"
    return axiosClient.post(url, {});
  },
  testDelete: (code) => {

    const url = "/updateLookup?appname=" + appname + "&lookupcode=" + code + "&type=Tests&statusType=delete"
    return axiosClient.post(url, {});
  },
  llDelete: (id) => {

    const url = '/updateLectureLibrary?appname=' + appname + '&lecturelibraryid=' + id + "&type=delete";
    return axiosClient.post(url, {});
  },
  caseDelete: (id) => {

    const url = "/updateLearningCase?appname=" + appname + "&caseid=" + id + "&type=delete"
    return axiosClient.post(url, {});
  },
  moduleDelete: (id) => {

    const url = "/updateModule?appname=" + appname + "&moduleid=" + id + "&type=delete"
    return axiosClient.post(url, {});
  },
  moduleInfo: (id) => {
    const userid = localStorage.getItem("userId")
    const url = "/moduleInfo?appname=" + appname + "&moduleid=" + id + "&userid=" + userid
    return axiosClient.get(url);
  },
  getmoduleInfoById: (id) => {
    const userid = localStorage.getItem("userId")
    const url = "/moduleInfo?appname=" + appname + "&moduleid=" + id
    return axiosClient.get(url);
  },
  getBiopsyRefNumber: () => {
    const url = "/getBiopsyRefNumbers?appname=" + appname
    return axiosClient.get(url);
  },
  clientDataUpdate: (params) => {
    const token = localStorage.getItem("token")
    const clientid = localStorage.getItem("clientid")
    const url = "/updateClient?appname=" + appname + "&clientid=" + clientid
    return axiosClient.post(url, params);
  },

  pwdGenerate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/setPassword?appname=" + appname + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  pwdGenerateAdmin: (params, id) => {
    const url = "/setPassword?appname=" + appname + '&userid=' + id;
    return axiosClient.post(url, params);
  },
  clientPwdGenerate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateClientPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },
  clientForgotPwdGenerate: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/forgotClientPassword?appname=" + appname;
    return axiosClient.post(url, params);
  },
  clientSearch: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientSearch?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  AllDeals: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientEnquiry?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  UpdateDeals: (params) => {
    let payload = params;
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/clientEnquiry?appname=" + appname + "&enquiryid=" + params.enquiryid + "&token=" + token + '&userid=' + userid;
    if (payload.hasOwnProperty('enquiryid')) delete payload['enquiryid']
    return axiosClient.put(url, payload);
  },

  UpdateFollowupDeals: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/enquiryFollowup?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  AddDeal: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/clientEnquiry?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  AddLead: (params) => {

    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const payload = { ...params }
    const url = "/addLead?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.put(url, payload);
  },
  NotifyAdmin: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/notifyAdmin?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.post(url, params);
  },
  AddConversation: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addConversation?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    return axiosClient.put(url, payload);
  },
  GetConversations: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/conversations?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid;
    return axiosClient.get(url, payload);
  },
  UpdateConvData: (params) => {
    const payload = params
    const token = localStorage.getItem("token")
    const url = "/updateConversation?appname=" + appname + "&token=" + token + "&conversationid=" + params.conversationid + "&status=" + params.status;
    if (payload.hasOwnProperty('status')) delete payload['status']
    if (payload.hasOwnProperty('conversationid')) delete payload['conversationid']
    return axiosClient.post(url, payload);
  },
  UpdateLead: (params) => {
    const payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateLead?appname=" + appname + "&token=" + token + '&userid=' + userid + '&leadid=' + params.leadid + '&clientid=' + params.clientid;
    if (payload.hasOwnProperty('leadid')) delete payload['leadid']
    if (payload.hasOwnProperty('clientid')) delete payload['clientid']
    return axiosClient.post(url, payload);
  },
  GetConversationComments: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/addConversationComment?appname=" + appname + "&token=" + token + '&userid=' + userid + '&conversationid=' + params.conversationid;
    if (payload.hasOwnProperty('conversationid')) delete payload['conversationid']
    return axiosClient.post(url, payload);
  },
  GetConversationsCommentData: (params) => {
    let payload = params
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/updateconversationComment?appname=" + appname + "&token=" + token + '&userid=' + userid + '&commentid=' + params.leadid;
    return axiosClient.get(url, payload);
  },
  GetLeads: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/leads?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.get(url, params);
  },

  GetSellers: (params) => {
    const token = localStorage.getItem("token")
    const url = "/companyList?appname=" + appname + "&token=" + token;
    return axiosClient.get(url, params);
  },


  GetBuyers: (params) => {
    const token = localStorage.getItem("token")
    const url = "/blockCompanyList?appname=" + appname + "&token=" + token + "&companyid=" + params.id;
    return axiosClient.get(url, params);
  },

  GetBlockBuyers: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")
    const url = "/getblockCompanies?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },


  mapImport: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/importDataV2?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },

  addCpc: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/addCpc?appname=" + appname + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  updateCpc: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/updateCpc?appname=" + appname + "&token=" + token + '&userid=' + userid;
    return axiosClient.post(url, params);
  },
  deleteCpc: (params) => {
    const token = localStorage.getItem("token")
    const userid = localStorage.getItem("userId")

    const url = "/updateCpc?appname=" + appname + "&token=" + token + '&userid=' + userid + '&type=delete';
    return axiosClient.post(url, params);
  },
  getBiddingLookUp: (params) => {
    const token = localStorage.getItem("token")
    let payload = params

    let status = params?.status ? params?.status : "";
    let url = "/biddingLookups?appname=" + appname + "&token=" + token;
    if (status != "") { url = url + `&status=ACTIVE`; }
    if (payload.hasOwnProperty('status')) delete payload['status']
    return axiosClient.post(url, payload);
  },
  
   // In your tmdbApi file, add this method:
  sendCpcMail: (params) => {
    const token = localStorage.getItem("token");
    let payload = params;

    let url =
      "/cpcMailStartTime?appname="+appname+"&activeQuizMail=true&token=" + token;

    return axiosClient.post(url, payload);
  },


  navigatePage: (userType, navigate) => {
    userType = userType.toLowerCase();
    // if (userType === "clinician") {
    //   navigate("/caseupload")
    // } 
    if (userType === "doctor") {
      navigate('/cpc')
    }
    else if (userType === "lab technician") {
      navigate('/biopsy/cases')

    } else if (userType === "pathologist") {
      navigate('/dashboard')
    } else if (userType === "teaching admin") {
      navigate('/biopsy/cases')
    } else if (userType === "admin") {
      // navigate('/dashboard')
      navigate('/cases')
    }

    // else if (userType === "student") {
    //   navigate('/studentcpc')
    // }
  },

  importCases: (params) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");
    const url = "/importcases?appname=" + appname + "&userid=" + userid + "&token=" + token;
    return axiosClient.post(url, params);
  },

  createCases: (params) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");
    const url = "/createcases?appname=" + appname + "&userid=" + userid + "&token=" + token;
    return axiosClient.post(url, params);
  },

  generateShareUrl: (caseid, params) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");
    const url = `/generateCaseUrl?appname=${appname}&caseid=${caseid}&userid=${userid}&token=${token}`;
    return axiosClient.post(url, { ...params, caseid });
  },

  getShareInfo: (caseid, fileid) => {
    const token = localStorage.getItem("token");
    const userid = localStorage.getItem("userId");
    const url = `/getShareCaseDetails?appname=${appname}&caseid=${caseid}&fileid=${fileid}&userid=${userid}&token=${token}`;
    return axiosClient.get(url);
  },

  validateShareUrl: (shareid) => {
    const url = `/getShareCaseDetails?appname=${appname}&shareid=${shareid}`;
    return axiosClient.post(url);
  },

  getAllShareCaseDetails: ({ page, pageSize, search }) => {
    const userid = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    const searchQuery = search ? `&search=${encodeURIComponent(search)}` : "";
    const url = `/getShareCaseDetails?appname=${appname}&userid=${userid}&token=${token}${searchQuery}&paginate=true&pageNumber=${page}&pageSize=${pageSize}`;
    return axiosClient.post(url);
  },

  getShareHistoryDetails: (shareid) => {
    const userid = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    const url = `/getShareCaseDetails?appname=${appname}&userid=${userid}&token=${token}&shareid=${shareid}&sharehistory=true`;
    return axiosClient.post(url);
  },

  // backend recalculates the expiry dates from the hours sent (counted from now)
  updateShareHistory: (shareid, hours) => {
    const userid = localStorage.getItem("userId");
    const token = localStorage.getItem("token");
    const url = `/getShareCaseDetails?appname=${appname}&userid=${userid}&token=${token}&shareid=${shareid}&sharehistoryupdate=true`;
    return axiosClient.post(url, { hours, shareid });
  },

};



export default tmdbApi;